import { ExamDateDto } from "api";
import { DateTime } from "luxon";

export const usePaymentDeadline = (examDateDto?: ExamDateDto) => {
  const calculatedDeadline = DateTime.now().plus({
    days: examDateDto?.paymentDeadlineDays,
  });
  const paymentEndDate = examDateDto?.paymentEndDate
    ? DateTime.fromISO(examDateDto?.paymentEndDate)
    : null;

  let result: DateTime<true>;

  if (paymentEndDate && paymentEndDate.isValid) {
    result =
      calculatedDeadline.toMillis() < paymentEndDate.toMillis()
        ? calculatedDeadline
        : paymentEndDate;
  } else {
    result = calculatedDeadline;
  }

  return result.toISODate();
};
